import { render, staticRenderFns } from "./SecondStep.vue?vue&type=template&id=48a40c89&scoped=true"
import script from "./SecondStep.vue?vue&type=script&lang=js"
export * from "./SecondStep.vue?vue&type=script&lang=js"
import style0 from "./SecondStep.vue?vue&type=style&index=0&id=48a40c89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a40c89",
  null
  
)

export default component.exports